import {createFileRoute} from '@tanstack/react-router'
import ClashOfTeamsList from "../../../clash-of-teams/ClashOfTeamsList";

export const Route = createFileRoute('/_app/clash-of-teams/')({
    component: () => <ClashOfTeamsList />,
})
